import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon-button',
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss']
})
export class IconButtonComponent implements OnInit {
  @Input() icon: string = '';
  @Input() color: string = 'primary';
  @Input() disabled: boolean = false;

  @Input() stroke: boolean = false;
  @Input() fliko: boolean = false;
  @Input() inverse: boolean = false;

  constructor() {}

  ngOnInit() {}
}
